export default "__VITE_ASSET__B28B9O0N__"